import React from 'react'
import { Box, Typography, Modal, Button, Paper, Fade } from '@mui/material'
import moment from 'moment'
import { Services } from '../../../services'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'

const HistoricoAgendamento = ({ pedido }) => {
  const { modaisAgend, actionsAgend } = React.useContext(AgendamentoContext)
  const { userUCtx } = React.useContext(UsuarioContext)

  const formataDiaEHora = date => moment(date).format('dddd, DD/MM/YY [às] HH:mm')
  const formataDiaEHoraAgendada = (start, end) => `${moment(start).format('dddd, DD/MM/YY [das] HH:mm')} até ${moment(end).format('HH:mm')}`

  const closeModal = () => actionsAgend.handleModaisAgend('historicoAgendamento', false)

  const reagendamentos = pedido.reagendamentos || []
  const pedidoOriginal = reagendamentos.length ? reagendamentos[0] : pedido
  const pagamentoLocal = pedido.formaPagamento === 'LOCAL' || pedido.formaPagamento === 'MAQUINA_CARTAO' || pedido.formaPagamento === 'DINHEIRO'

  const renderFieldChange = (label, oldVal, newVal) => {
    if (oldVal === newVal) return null
    return (
      <Typography sx={textStyle}>
        {label} de: {oldVal ?? '--'} para: {newVal ?? '--'}
      </Typography>
    )
  }

  const textStyle = {
    fontSize: { xs: '11px', sm: '12px', md: '13px', lg: '14px' },
    width: '100%',
    fontFamily: 'jost-light',
    color: 'text.grey',
    fontWeight: 'bold',
  }

  return (
    <Modal open={modaisAgend.historicoAgendamento} onClose={closeModal}>
      <Fade in={modaisAgend.historicoAgendamento}>
        <Paper
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
            maxWidth: 600,
            p: 2,
          }}
          elevation={2}
        >
          <Box display='flex' flexDirection='column' gap={0.4}>
            <Typography color='primary' align='center' gutterBottom sx={{ fontWeight: 'bold', typography: { xs: 'h6', md: 'h5' } }}>
              Histórico do Agendamento
            </Typography>

            {/* Pedido original */}
            <Box display='flex' flexDirection='column'>
              {pedidoOriginal.marketplace ? (
                <>
                  <Typography sx={textStyle}>Solicitado por mim em: {formataDiaEHora(pedidoOriginal.createdAt)}</Typography>
                  {!pagamentoLocal ? (
                    <Typography sx={textStyle}>
                      Aprovado automaticamente por pagamento online em: {formataDiaEHora(pedidoOriginal.createdAt)}
                    </Typography>
                  ) : (
                    pedidoOriginal.status === 'AGENDADO' && (
                      <Typography sx={textStyle}>
                        Aprovado {pedidoOriginal.empresa?.nome ? 'por ' + pedidoOriginal.empresa.nome : 'pelo centro esportivo'} em:{' '}
                        {formataDiaEHora(pedidoOriginal.dataAprovacao)}
                      </Typography>
                    )
                  )}
                </>
              ) : (
                <Typography sx={textStyle}>
                  Marcado por {pedidoOriginal.empresa?.nome || 'centro esportivo'} em: {formataDiaEHora(pedidoOriginal.createdAt)}
                </Typography>
              )}
            </Box>

            {/* Reagendamentos */}
            {reagendamentos.map((reschedule, idx) => {
              const lastItem = idx === reagendamentos.length - 1
              const next = !lastItem ? reagendamentos[idx + 1] : pedido

              return (
                <Box key={reschedule.idReagendamento} display='flex' flexDirection='column'>
                  {pedido.criadoPor.toLowerCase() === 'usuario' || pedido.criadoPor === userUCtx.usuario.nome ? (
                    <Typography sx={textStyle}>
                      {lastItem && (pedido.status === 'SOLICITADO' || pedido.status === 'CANCELADO') ? 'Reagendamento solicitado' : 'Reagendado'} em:{' '}
                      {formataDiaEHora(next.createdAt)}
                    </Typography>
                  ) : (
                    <Typography sx={textStyle}>Reagendado em: {formataDiaEHora(next.createdAt)}</Typography>
                  )}
                  {pagamentoLocal &&
                    (pedido.criadoPor.toLowerCase() === 'usuario' || pedido.criadoPor === userUCtx.usuario.nome) &&
                    pedido.status !== 'SOLICITADO' &&
                    pedido.status !== 'CANCELADO' && (
                      <Typography sx={textStyle}>
                        Aprovado {next.empresa?.nome ? 'por ' + next.empresa.nome : 'pelo centro esportivo'} em: {formataDiaEHora(next.dataAprovacao)}
                      </Typography>
                    )}

                  <Box display='flex' flexDirection='column' pl={0.6}>
                    {renderFieldChange(
                      'Horário alterado',
                      formataDiaEHoraAgendada(reschedule.dataInicio, reschedule.dataFim),
                      formataDiaEHoraAgendada(next.dataInicio, next.dataFim ?? pedido.dataFinal),
                    )}
                    {renderFieldChange('Quadra alterada', reschedule.quadra?.descricao, next.quadra?.descricao)}
                    {renderFieldChange(
                      'Forma de pagamento alterada',
                      Services.ReturnMetodoPay(reschedule.formaPagamento),
                      Services.ReturnMetodoPay(next.formaPagamento),
                    )}
                    {renderFieldChange('Esporte alterado', reschedule.categoriaEsporte?.nome, next.categoriaEsporte?.nome)}
                    {renderFieldChange(
                      'Valor total atualizado',
                      `R$ ${parseFloat(reschedule.valorTotal).toFixed(2).replace('.', ',')}`,
                      `R$ ${parseFloat(next.valorTotal).toFixed(2).replace('.', ',')}`,
                    )}
                  </Box>
                </Box>
              )
            })}

            {/* Cancelamento geral */}
            {pedido.status === 'CANCELADO' && (
              <Typography sx={textStyle}>
                Cancelado por
                {pedido.canceladoPor.toLowerCase() === 'usuario' || pedido.canceladoPor === userUCtx.usuario.nome ? ' mim' : pedido.empresa.nome} em:
                em: {formataDiaEHora(pedido.dataCancelamento)}
              </Typography>
            )}

            <Box display='flex' justifyContent='center' mt={2}>
              <Button variant='outlined' onClick={closeModal}>
                Fechar
              </Button>
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  )
}

export default HistoricoAgendamento
